import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Sirve si nunca estudié biodescodificación antes?',
  a: 'Sí. El Tomo I — Fundamentos — está diseñado para empezar desde cero absoluto. No necesitás experiencia previa de ningún tipo.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en formato PDF. Acceso inmediato después del pago. Te llega por email con el link de descarga en menos de 5 minutos. Podés leerlo en celular, tablet o computadora. Podés imprimirlo si preferís trabajar en papel.'
}, {
  q: '¿Puedo usarlo para atender clientes reales?',
  a: 'Sí. Los 6 tomos más los 6 bonos están diseñados específicamente para que puedas atender con protocolos reales desde el primer día. El Bono 1 — Kit de Primera Sesión — te da todo lo que necesitás para tu primera sesión.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una sola compra, para siempre. Sin mensualidades ni renovaciones de ningún tipo.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios. Sin burocracia. Sin drama.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border border-white/10 rounded-xl bg-[#111111] overflow-hidden transition-all duration-300" data-id="element-103">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-104">
        <span className="text-white font-bold text-base md:text-lg pr-4" data-id="element-105">
          {q}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-[#eab308] text-black' : 'bg-white/5 text-[#eab308]'}`} data-id="element-106">
          {isOpen ? <MinusIcon size={18} data-id="element-107" /> : <PlusIcon size={18} data-id="element-108" />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-109">
        <div className="p-5 pt-0 text-gray-400 text-sm md:text-base leading-relaxed border-t border-white/5 mt-2" data-id="element-110">
          {a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [ref, vis] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-111">
      <div className="container mx-auto max-w-3xl" data-id="element-112">
        <div ref={ref} className={`reveal text-center mb-10 ${vis ? 'is-visible' : ''}`} data-id="element-113">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-white tracking-wide" data-id="element-114">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-115">
          {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-116" />)}
        </div>
      </div>
    </section>;
}